<template>
  <form @submit.prevent="changePassword" ref="form">
    <card>
      <h2 slot="header" class="card-title">{{$t('page_user.change_password')}}</h2>
      <div class="row">
        <div class="col-lg-3">
          <base-alert v-if="submitted && success" type="success" dismissible>
            <span>{{$t('page_user.password_success')}}</span>
          </base-alert>
          <base-input
            type="password"
            v-validate="'required|min:5'"
            data-vv-as="new password"
            name="new_password"
            :error="getError('new_password')"
            :label="$t('page_user.new_password')"
            :placeholder="$t('page_user.new_password')"
            v-model="model.newPassword"
            ref="newPassword"
          >
          </base-input>
          <base-input
            type="password"
            v-validate="'required|confirmed:newPassword'"
            data-vv-as="confirm new password"
            name="confirm_new_password"
            :error="getError('confirm_new_password')"
            :label="$t('page_user.confirm_new_password')"
            :placeholder="$t('page_user.confirm_new_password')"
            v-model="model.confirmNewPassword"
          >
          </base-input>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p class="disclaimer-browser mt-2">{{$t('general.disclaimer_browser')}}</p>

          <base-checkbox class="terms-label mt-4" :class="{ 'has-danger': getError('terms') }" name="terms" v-validate="'required:true'" v-model="terms">
            <i18n path="auth.register__terms_agree" tag="span">
              <a href="https://biopama.org/terms-and-conditions" target="_blank">{{ $t('auth.register__terms') }}</a>
              <a href="https://biopama.org/terms-and-conditions" target="_blank">{{ $t('auth.register__privacy') }}</a>
            </i18n>
          </base-checkbox>
          <base-checkbox class="terms-label" :class="{ 'has-danger': getError('termsIucn') }" name="termsIucn" v-validate="'required:true'" v-model="termsIucn">
            <i18n path="auth.register__terms_iucn" tag="span">
              <a href=" https://www.iucn.org/privacy-policy" target="_blank">{{ $t('auth.register__privacy_iucn') }}</a>
            </i18n>
          </base-checkbox>
        </div>
      </div>
      <base-button native-type="submit" type="primary" size="lg" class="btn-fill mt-4">
        {{$t('page_user.submit')}}
      </base-button>
    </card>
  </form>
</template>
<script>
  import {UserService} from '@/services';
  import {BaseAlert} from 'src/components';

  export default {
    data() {
      return {
        submitted: false,
        success: false,
        model: {},
        terms: false,
        termsIucn: false
      };
    },
    components: {
      BaseAlert
    },
    methods: {
      async changePassword() {
        let isValidForm = await this.$validator.validateAll();
        if (isValidForm) {
          this.submitted = false;
          this.success = false;
          let loader = this.$loading.show();
          await UserService.setNewPassword({
            newPassword: this.model.newPassword,
            confirmNewPassword: this.model.confirmNewPassword
          }).then((response) => {
            this.success = true;

          }).catch((error) => {

          })

          loader.hide();
          this.$refs.form.reset();
          this.submitted = true;
          window.location.href = '/dashboard';
        }
      },
      getError: function (fieldName) {
        return this.errors.first(fieldName);
      }
    }
  };
</script>
<style scoped lang="scss">
  .has-danger span {
    color: $danger !important;
  }
  .has-error {
    color: $danger;
    margin-top: 4px;
    margin-left: 0.75rem;
  }
  .terms-label {
    font-size: 1.62291667vh;
    font-weight: 400;
    color: $secondary;

    &.has-danger {
      a {
        color: $danger;
      }
    }

    a {
      text-decoration: underline;
    }
  }
</style>
